import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
} from "@mui/material";
import { OffensiveFormation } from "../../../../types/LogTypes";
import { useLogger } from "../../../../contexts/LoggerContext";
import { GainLossInput } from "../Components/GainLossInput";

export const DefensePlayLog = () => {
  const [selectedFormation, setSelectedFormation] =
    useState<OffensiveFormation | null>(null);
  const [selectedRunPass, setSelectedRunPass] = useState<"R" | "P">("R");
  const [gainLoss, setGainLoss] = useState<number>(0);
  const { setCurrentPlayLog, clearSelections } = useLogger();

  useEffect(() => {
    if (selectedFormation) {
      setCurrentPlayLog({
        offensive_formation: selectedFormation,
        gain_loss: gainLoss,
        run_pass: selectedRunPass,
      });
    }
  }, [selectedFormation, gainLoss, selectedRunPass]);

  useEffect(() => {
    if (clearSelections) {
      setSelectedFormation(null);
      setGainLoss(0);
    }
  }, [clearSelections]);

  const offensiveFormations: OffensiveFormation[] = [
    "TRIPS",
    "PRO",
    "ACE_SLOT",
    "CHEETAH",
    "DOUBLE_SLOT",
    "2x2",
    "3x1",
    "EMPTY"
  ];

  const handleFormationChange = (
    event: SelectChangeEvent<OffensiveFormation | "">
  ) => {
    setSelectedFormation(event.target.value as OffensiveFormation);
  };

  const handleRunPassChange = (event: SelectChangeEvent<"R" | "P">) => {
    setSelectedRunPass(event.target.value as "R" | "P");
  };

  return (
    <Paper elevation={3} sx={{ p: 1 }}>
      <Box>
        <Grid container spacing={3}>
          {/* Formation and Run/Pass */}
          <Grid item xs={12} md={6}>
            <FormControl fullWidth sx={{ mb: 1, minWidth: 200 }}>
              <InputLabel id="formation-label">Offensive Formation</InputLabel>
              <Select
                labelId="formation-label"
                id="formation"
                value={selectedFormation || ""}
                label="Offensive Formation"
                onChange={handleFormationChange}
              >
                {offensiveFormations.map((formation) => (
                  <MenuItem key={formation} value={formation}>
                    {formation}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>{" "}
            <FormControl fullWidth sx={{ mb: 1, minWidth: 200, marginTop: 2 }}>
              <InputLabel id="run-pass-label">Run Pass</InputLabel>
              <Select
                labelId="run-pass-label"
                id="run-pass"
                value={selectedRunPass}
                label="Run or Pass"
                onChange={handleRunPassChange}
              >
                <MenuItem key="R" value="R">
                  Run
                </MenuItem>
                <MenuItem key="P" value="P">
                  Pass
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
          
          {/* Gain/Loss */}
          <Grid item xs={12} md={6}>
            <GainLossInput
              value={gainLoss}
              onChange={setGainLoss}
              label="Gain/Loss"
            />
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
};
